import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import BasicRules from './BasicRules.vue'
    import SingleQuestion from './SingleQuestion.vue'
    import ProvidedFeedback from './ProvidedFeedback.vue'
    import EndConditions from './EndConditions.vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    step: null
  },
  setup(__props: any) {

const props = __props as {
        step: number
    }

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.step === 1)
      ? (_openBlock(), _createBlock(BasicRules, { key: 0 }))
      : _createCommentVNode("", true),
    (props.step === 2)
      ? (_openBlock(), _createBlock(SingleQuestion, { key: 1 }))
      : _createCommentVNode("", true),
    (props.step === 3)
      ? (_openBlock(), _createBlock(ProvidedFeedback, { key: 2 }))
      : _createCommentVNode("", true),
    (props.step === 4)
      ? (_openBlock(), _createBlock(EndConditions, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})